import { render, staticRenderFns } from "./problems.vue?vue&type=template&id=205f4ace&scoped=true&"
import script from "./problems.vue?vue&type=script&lang=js&"
export * from "./problems.vue?vue&type=script&lang=js&"
import style0 from "./problems.vue?vue&type=style&index=0&id=205f4ace&lang=scss&scoped=true&"
import style1 from "./problems.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f4ace",
  null
  
)

export default component.exports